import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import './BlogDetail.css';

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      setLoading(true);
      const q = query(
        collection(db, "blogs"),
        where("slug", "==", slug)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setBlog(snapshot.docs[0].data());
      } else {
        console.log("No blog found");
      }
      setLoading(false);
    };

    fetchBlog();
    
  }, [slug]);

  if (loading) {
    return (
      <div className="blog-detail-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!blog && !loading) {
     return (
      <div className="blog-detail-not-found">
        <h2>Blog Not Found</h2>
        <Link to="/blogs" className="btn-secondary">Return to Blogs</Link>
      </div>
     );
  }

  return (
  <>
    <Helmet>
      <title>{blog.title} | Almond Softwares</title>
      <meta name="description" content={blog.content ? blog.content.substring(0, 150) : "Read our latest blog post."} />
    </Helmet>
    <div className="blog-detail-page">
      <div className="bg-luxury"></div>
      <div className="container">
        <motion.div 
          className="blog-detail-wrapper"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Link to="/blogs" className="back-link">
            &larr; Back to Blogs
          </Link>

          <h1 className="blog-title">{blog.title}</h1>

          <div className="blog-meta-info">
            <span className="author">Almond Softwares</span>
            <span className="dot">•</span>
            <span className="read-time">5 min read</span>
          </div>

          <div className="blog-content-body">
            {blog.content.split('\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>

          <div className="blog-footer">
             <Link to="/contact" className="btn-primary">Discuss Your Project</Link>
          </div>
        </motion.div>
      </div>
    </div>
  </>
  );
}